import styled from 'styled-components';

import {
  borderRadius8,
  boxShadow815Grey,
} from 'approot/shared/styles/borders.style';
import { grey1, grey5 } from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import { ACTIVITY_SHEET_CONTENT_MAX_WIDTH } from '../../shared/sheet/activity-sheet.style';

export const DrawActivityInstructionInner = styled.div`
  ${boxShadow815Grey}
  background-color: ${grey1};
  border-radius: ${rem(borderRadius8)};
  border: 1px solid ${grey5};
  margin: 0 auto;
  max-width: ${rem(ACTIVITY_SHEET_CONTENT_MAX_WIDTH)};
  padding: ${rem(spacing16)};
`;

type DrawActivityInstructionProps = {
  $isVisible: boolean;
};
export const DrawActivityInstruction = styled.div<DrawActivityInstructionProps>`
  ${({ $isVisible }) =>
    !$isVisible
      ? `
    position: absolute;
    left: ${rem(spacing16)};
    top: ${rem(spacing16)};
  `
      : `
    position: relative;
    padding: ${rem(spacing16)};
  `};

  z-index: 1;
`;
